
"use client";

import { useState } from "react";
import Link from "next/link";
import { Mail, Menu, Handshake, Users, Calendar } from "lucide-react";
import { Button } from "./ui/button";
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle, SheetTrigger } from "./ui/sheet";
import { cn } from "@/lib/utils";
import Image from "next/image";

const navLinks = [
    { href: "/el-evento", text: "El Evento", icon: Calendar },
    { href: "/organizadores", text: "Organizadores", icon: Users },
    { href: "/patrocinio", text: "Patrocinio", icon: Handshake },
    { href: "/contacto", text: "Contacto", icon: Mail },
]

export function MobileNav() {
  const [isOpen, setIsOpen] = useState(false);

  const closeSheet = () => setIsOpen(false);

  return (
    <Sheet open={isOpen} onOpenChange={setIsOpen}>
      <SheetTrigger asChild>
        <Button variant="outline" size="icon" className="text-white bg-transparent border-primary hover:bg-primary/20 hover:text-white">
          <Menu className="h-6 w-6" />
          <span className="sr-only">Abrir menú</span>
        </Button>
      </SheetTrigger>
      <SheetContent side="right" className="w-full max-w-sm bg-card text-card-foreground flex flex-col p-0">
        <SheetHeader className="p-4 border-b">
            <SheetTitle className="sr-only">Menú de navegación principal</SheetTitle>
            <SheetDescription className="sr-only">
                Una lista de enlaces para navegar por el sitio web.
            </SheetDescription>
            <Link href="/" onClick={closeSheet} className="flex items-center justify-center">
                <Image src="/img/logo.png" alt="Sin Gluten Experience Day Logo" width={180} height={53} />
            </Link>
        </SheetHeader>
        <div className="flex-1 flex flex-col overflow-hidden">
            <div className="flex-1 overflow-y-auto p-6">
                <nav className="flex flex-col items-stretch justify-start gap-4 text-lg font-medium">
                    {navLinks.map((link, index) => {
                        const Icon = link.icon;
                        return (
                            <Link 
                                key={link.href}
                                href={link.href} 
                                onClick={closeSheet} 
                                className={cn(
                                    "flex items-center gap-4 p-4 rounded-lg border border-transparent text-foreground transition-all duration-300 ease-in-out hover:bg-muted hover:border-border",
                                    isOpen ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-4"
                                )}
                                style={{ transitionDelay: `${index * 100 + 200}ms`}}
                                prefetch={false}>
                                    <Icon className="w-6 h-6 text-primary" />
                                    <span>{link.text}</span>
                            </Link>
                        )
                    })}
                </nav>
            </div>
            <div className="p-6 mt-auto border-t">
                <Button size="lg" asChild className="w-full font-bold bg-primary text-primary-foreground hover:bg-primary/90">
                <Link href="/waiting-list" onClick={closeSheet}>
                    <Mail className="mr-2" />
                    Waiting list 2026
                </Link>
                </Button>
            </div>
        </div>
      </SheetContent>
    </Sheet>
  );
}
